import type { z } from 'zod';

import type {
    clientActivityItemSchema,
    generateSessionInputSchema,
    generateSessionOutputSchema,
    generationStatusSchema,
    getClientActivityOutputSchema,
    getClientServiceCodesOutputSchema,
    getSessionListOutputSchema,
    inputMethodSchema,
    resolveActionInputSchema,
    scheduleSessionInputSchema,
    scheduleSessionOutputSchema,
    sessionActionsSchema,
    sessionListItemSchema,
    sessionNoteStatusSchema,
    sessionNoteTypeSchema,
    sessionSchema,
    updateSessionInputSchema,
} from './session.schemas';

export type InputMethod = z.infer<typeof inputMethodSchema>;
export type GenerationStatus = z.infer<typeof generationStatusSchema>;
export type Session = z.infer<typeof sessionSchema>;
export type SessionStatus = Session['status'];
export type SessionNoteStatus = z.infer<typeof sessionNoteStatusSchema>;
export type TreatmentApproach = Session['treatmentApproaches'][number];
export type SessionActions = z.infer<typeof sessionActionsSchema>;
export type SessionAction = SessionActions[number];
export type SessionListItem = z.infer<typeof sessionListItemSchema>;

export type ClientActivityItem = z.infer<typeof clientActivityItemSchema>;
export type GetClientActivityOutput = z.output<typeof getClientActivityOutputSchema>;
export type GetSessionListOutput = z.output<typeof getSessionListOutputSchema>;
export type GenerateSessionInput = z.input<typeof generateSessionInputSchema>;
export type GenerateSessionOutput = z.output<typeof generateSessionOutputSchema>;
export type UpdateSessionInput = z.input<typeof updateSessionInputSchema>;
export type ResolveActionInput = z.input<typeof resolveActionInputSchema>;
export type NoteType = z.infer<typeof sessionNoteTypeSchema>;

export type ScheduleSessionInput = z.input<typeof scheduleSessionInputSchema>;
export type ScheduleSessionOutput = z.output<typeof scheduleSessionOutputSchema>;
export type GetClientServiceCodesOutput = z.output<typeof getClientServiceCodesOutputSchema>;

export const generationStepStatus = {
    IDLE: 'idle',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
} as const;

export type GenerationStepStatus = (typeof generationStepStatus)[keyof typeof generationStepStatus];

export type SessionType = 'in-person' | 'telehealth';
export type PlatformType = 'chrome' | 'desktop-app';

export type SessionListFilters = {
    search?: string;
    start_date?: string;
    end_date?: string;
    status?: SessionNoteStatus;
    client_id?: string;
    order?: 'asc' | 'desc';
    page_size?: number;
    cursor?: string | null;
    exclude_first_generation?: boolean;
};
